import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — an exterior brick wall segment: brick red with thin darker
// horizontal course lines slightly proud of both faces, so the coursing
// reads at a glance. Same dimensions as wall-plain (1 m long, 0.12 thick,
// 2.6 high, along X through the tile centre).
const BRICK = "#a05a40";
const MORTAR_DARK = "#824834";

export const wallBrick = defineModel({
  id: "wall-brick",
  batchId: "modern",
  name: "Brick wall",
  tags: ["modern", "outdoor", "structure", "wall", "brick", "exterior"],
  summary: "An exterior brick wall segment with dark course lines.",
  description:
    "A one-tile exterior brick wall of the Modern Living kit: brick red " +
    "with thin darker horizontal course lines, 0.12 m thick and 2.6 m " +
    "high, running along X through the tile centre like every wall piece.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // the brick body
      { geometry: new THREE.BoxGeometry(1.0, 2.6, 0.12), color: BRICK, position: [0, 1.3, 0] },
      // thin darker course lines, slightly proud of both faces
      { geometry: new THREE.BoxGeometry(1.0, 0.03, 0.13), color: MORTAR_DARK, position: [0, 0.65, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.03, 0.13), color: MORTAR_DARK, position: [0, 1.3, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.03, 0.13), color: MORTAR_DARK, position: [0, 1.95, 0] },
    ];
  },
  animations: [],
});
